<template>
  <div style="display:flex; justify-content:center; margin-top:35vh">
    <div>
      <img src="../assets/images/404.png"
           style="width:400px">
    </div>
    <div style="margin-left:70px">
      <span style="font-size: 150px;font-family: 方正准圆-标准;">
        404
      </span>
      <p style="font-size: 36px;font-family: SourceHanSansSC-regular; ">ON NO！页面丢失啦！</p>
      <p style="font-size: 20px;font-family: SourceHanSansSC-regular;">您所访问的页面不存在，请点击下面的按钮返回主页。</p>
      <button style="color:black;background-color:white;border-radius:20px; width:180px; height:40px;flex-shrink:0;font-size:16px; font-style:Roboto; border-color: black;cursor: pointer;"
              @click='returnIndex'>返回首页</button>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  methods: {
    returnIndex() {
      this.$router.push("/");
    },
  },
  setup() {
    return {};
  },
});
</script>
<style scoped>
</style>
